import { LayoutsStream } from "../types";

export default function(): LayoutsStream {
    return {
        ready: Promise.resolve(undefined),
        subscribe: () => { /** */ },
        onEvent: (callback: (streamEvent: any) => void) => () => {/** */ },
        waitFor: (token: string, timeout: number) => Promise.resolve(undefined),
        gotSnapshot: Promise.resolve(undefined),
    };
}
